import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { Suspense, useEffect, useMemo } from 'react';
import RouteIdentifier from './AppSystem/Routing/Components/RouteIdentifier';
import { useRoutes } from './AppSystem/Routing/useRoutes';
import { getRoutes } from './AppSystem/Routing/Helper';
import { Main } from "./AppSystem/Layout/Main";
import './AppSystem/assets/css/LightThemeCustom.css';
import { I18nextProvider } from 'react-i18next';
import i18n from "./AppSystem/i18n";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "./AppSystem/Redux/Auth/AuthSlice";
import { CheckExpired } from "./AppSystem/Helpers/CheckJwtExpired";
import { redirectWhenCloseSession } from './Common/Helpers/RedirectWhenCloseSession';
import { Helmet } from 'react-helmet';
import { useMsal } from '@azure/msal-react';
import { jwtDecode } from 'jwt-decode';
import { InteractionStatus } from '@azure/msal-browser';
import SessionManager from './Common/Helpers/SessionManager';

let currentBranch = 'master'; 
(async () => {
    try {
        const response = await fetch('/branch-info.json');
        if (response.ok) {
            const data = await response.json();
            if (data && data.branch) {
                currentBranch = data.branch;
            }
        }
    } catch (error) {
        console.error("Error", error);
    }
})();


function App() {
    // LOGOUT USER IF REFRESH TOKEN IS EXPIRED
    const dispatch = useDispatch(); 
    const { instance, accounts, inProgress } = useMsal(); 
    const {tokenData, refreshTokenData, isAuthenticated } = useSelector(state => state.auth);

    // useEffect(() => {
    //     if (inProgress === InteractionStatus.None) {
    //         if (refreshTokenData && refreshTokenData?.expires != null&& CheckExpired('refreshToken', refreshTokenData?.expires) === true) {
    //             if (tokenData) {
    //                 const decodedToken = jwtDecode(tokenData);
    //                 const loginMethod = decodedToken?.loginMethod; 
    //                 // const activeAccount = instance.getActiveAccount() || accounts[0];
    //                 if(loginMethod && loginMethod.toLowerCase() === 'lrfssoentraid'){
    //                     dispatch(logoutUser());
    //                     // if(activeAccount){
    //                     // instance.logoutRedirect({ account: activeAccount });
    //                     // }
    //                     // else{
    //                     // instance.logoutRedirect();
    //                     // }
    //                 }else{
    //                     dispatch(logoutUser());
    //                     redirectWhenCloseSession(tokenData);
    //                 }
    //             }else {
    //                 //dispatch(logoutUser());
    //             }
    //         }
    //     }
    // }, [refreshTokenData, tokenData, instance, accounts, dispatch,inProgress]);

    let isCheckout = false;
    if (window.location.href.includes("checkout") || window.location.href.includes("qr-code-payment") || window.location.href.includes("qr-payment") || window.location.href.includes("redirect") || window.location.href.includes("ssologin") || window.location.href.includes("sso") || window.location.href.includes("entralogin")) {
        isCheckout = true;
    }

    const title =
        currentBranch === 'develop'
            ? 'TEST Digitala Kassan'
            : currentBranch === 'master'
                ? 'LRF Digitala Kassan'
                : 'LRF Digitala Kassan';

    const routesDataInfo = useRoutes();

    const routesData = useMemo(() => {
        if (!routesDataInfo || routesDataInfo.length === 0) {
            return [];
        }
        return getRoutes({
            data: routesDataInfo,
        });
    }, [routesDataInfo]);

    return (
        <I18nextProvider i18n={i18n}>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <Router>
                <SessionManager>
                <Suspense fallback="Loading">
                    {isAuthenticated && isCheckout === false ? (
                        <Main>
                            <div id="overlay"></div>
                            <div id="flash-message"></div>
                            <RouteIdentifier routes={routesData} />
                        </Main>
                    ) : (
                        <>
                            <div id="overlay"></div>
                            <div id="flash-message"></div>
                            <RouteIdentifier routes={routesData} />
                        </>
                    )}
                </Suspense>
                </SessionManager>
            </Router>
        </I18nextProvider>
    );
}

export default App;